import React, { Component } from 'react';
import './App.css';
import { Route, Switch } from 'react-router-dom';
import Layout from './components/layoutComponent/layout';
import { ToastContainer } from 'react-toastify';


class App extends Component {
  render() {

    return (
      <div className="App">
        <ToastContainer />
        <Switch>
          <Route path="/" component={Layout} />
        </Switch>
      </div>
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js